const html = require('choo/html');

module.exports = function(state) {
  const MAX_LENGTH = 32;

  return html`
    <div class="inline-block">
      <div class="flex mt-1">
        <label class="text-md" for="password-input">
          ${state.translate('password')}
        </label>

        <span
          class="question-icon self-center ml-1 cursor-pointer group"
          role="tooltip"
          aria-label="${state.translate('randomInfo')}"
        >
          <p class="tooltip">
            ${state.translate('randomInfo')}
          </p>
        </span>

        <label
          id="password-msg"
          for="password-input"
          class="self-end text-sm text-red mr-1 ml-auto dark:text-red-40
                  ${state.pwdError ? '' : 'invisible'}"
        >
          ${state.translate('maxPasswordLength', {
            length: MAX_LENGTH
          })}
        </label>
      </div>

      <input
        id="password-input"
        class="border-[1px] rounded focus:border-blue-60 leading-loose py-1 px-2 dark:bg-grey-80
              ${state.syndisInputs.pwdError ? 'border-red' : ''}"
        autocomplete="off"
        maxlength="${MAX_LENGTH}"
        type="password"
        oninput="${passwordChanged}"
        onfocus="${focused}"
        placeholder="${state.translate('unlockInputPlaceholder')}"
        value="${getPasswordString()}"
        data-item="password"
        ${state.syndisInputs.randomPwd ? 'disabled' : ''}
      />
    </div>

    <div class="checkbox inline-block mt-2 ml-3">
      <input
        id="random-password"
        type="checkbox"
        autocomplete="off"
        onchange="${toggleRandomPwd}"
        ${state.syndisInputs.randomPwd ? 'checked' : ''}
      />

      <label for="random-password">
        ${state.translate('random')}
      </label>
    </div>

    <div class="flex mt-1">
      <label class="text-md" for="phone-input">
        ${state.translate('phone')}
      </label>

      <span
        class="question-icon self-center ml-1 cursor-pointer group"
        role="tooltip"
        aria-label="${state.translate('phoneInfo') +
          ' ' +
          state.translate('commaSeperated')}"
      >
        <p class="tooltip">
          ${state.translate('phoneInfo') +
            ' ' +
            state.translate('commaSeperated')}
        </p>
      </span>

      <label
        id="phone-msg"
        class="self-end text-sm text-red mr-1 ml-auto dark:text-red-40
                ${state.phoneError ? '' : 'invisible'} "
        for="phone-input"
      >
        ${state.translate('invalid')}
      </label>
    </div>

    <input
      id="phone-input"
      class="w-full border-[1px] rounded leading-loose px-2 py-1 dark:bg-grey-80 
            ${state.syndisInputs.phoneError ? 'border-red' : ''}"
      type="text"
      autocomplete="off"
      oninput="${phoneChanged}"
      placeholder="${state.translate('phone')}"
      value="${state.syndisInputs.phoneInput || ''}"
      autocomplete="off"
      data-item="phone"
    />
  `;

  function toggleRandomPwd(event) {
    event.stopPropagation();
    const passwordInput = document.getElementById('password-input');

    if (event.target.checked) {
      passwordInput.setAttribute('disabled', true);
      passwordInput.classList.remove('border-red');
      passwordInput.value = '0000000000';
      state.syndisInputs.randomPwd = true;
    } else {
      passwordInput.removeAttribute('disabled');
      const phoneInput = document.getElementById('phone-input');
      phoneInput.classList.remove('border-red');
      passwordInput.value = state.archive.password;
      state.syndisInputs.phoneError = false;
      state.syndisInputs.randomPwd = false;
    }
    state.syndisInputs.pwdError = false;
  }

  function passwordChanged(event) {
    event.stopPropagation();
    event.preventDefault();

    const pwdmsg = document.getElementById('password-msg');

    state.syndisInputs.pwdError = false;
    const password = event.target.value;
    removeErrorEffect(event.target);

    if (password.length === MAX_LENGTH) {
      pwdmsg.textContent = state.translate('maxPasswordLength', {
        length: MAX_LENGTH
      });
    } else {
      pwdmsg.textContent = '';
    }
    state.archive.password = password;
  }

  function getPasswordString() {
    if (state.syndisInputs.randomPwd) {
      return '0000000000';
    }
    return state.archive.password || '';
  }

  function focused(event) {
    event.preventDefault();
    const el = document.getElementById('password-input');
    if (el.placeholder !== state.translate('unlockInputPlaceholder')) {
      el.placeholder = '';
    }
  }

  function phoneChanged(event) {
    event.stopPropagation();
    event.preventDefault();
    removeErrorEffect(event.target);
    state.syndisInputs.phoneError = false;
    state.syndisInputs.phoneInput = event.target.value;
  }

  function removeErrorEffect(target) {
    const item = target.dataset.item;
    const label = document.getElementById(item + '-msg');
    const input = document.getElementById(item + '-input');
    label.classList.add('invisible');
    input.classList.remove('border-red');
  }
};
